// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 239 ? "BookPreviewer" : chunkId) + "." + {"239":"98ed6b67","255":"52dcb77f","284":"6fc14fe1","405":"8f71504c","666":"63835413","942":"0e82568a"}[chunkId] + ".js";
};